<div class="assignee">
  <span class="assignee__label" [attr.id]="'assignee-' + kind + '-' + entityId">{{ label }}</span>

  <ng-container *ngIf="canEdit; else readonly">
    <select class="assignee__select" [ngModel]="selected" (ngModelChange)="change($event)" [disabled]="saving"
            [attr.aria-labelledby]="'assignee-' + kind + '-' + entityId">
      <option [ngValue]="null">{{ t('company.assign.none', 'Не назначен') }}</option>
      <option *ngFor="let o of options" [ngValue]="o.id">{{ o.fullName }}</option>
    </select>
    <span *ngIf="saved && !saving" class="assignee__ok" role="status">{{ t('company.assign.saved', 'Сохранено') }}</span>
  </ng-container>
  <ng-template #readonly>
    <strong class="assignee__value">{{ currentName || t('company.assign.none', 'Не назначен') }}</strong>
  </ng-template>

  <small *ngIf="error" class="assignee__err" role="alert">{{ error }}</small>
</div>
